export type CategoryTile = {
  title: string;
  image: string;
  link: string;
};

/**
 * The "Shop by category" tiles.
 *
 * This list was copy-pasted into six files (the homepage plus /why-dank,
 * /sameday-delivery, /mail-order-delivery, /how-delivery-works and the homepage
 * preview). When the artwork was replaced, the homepage was updated and the
 * other five kept serving the retired images, so the same category showed a
 * different picture depending on which page you were on. One definition now.
 *
 * This is the only definition. The list was briefly editable from the admin
 * panel, but the categories are fixed, so the endpoint and its editor were more
 * moving parts than the feature was worth.
 *
 * Images point at `covers/hero-<key>.webp`, the same files the /categories
 * page and the search hero use, so a category looks the same everywhere.
 */
export const DEFAULT_CATEGORY_TILES: CategoryTile[] = [
  {
    title: "Flowers",
    image: "/media/categories/covers/hero-flowers.webp",
    link: "/search?category=Flower",
  },
  {
    title: "Edibles",
    image: "/media/categories/covers/hero-edibles.webp",
    link: "/search?category=Edibles",
  },
  {
    title: "Beverages",
    image: "/media/categories/covers/hero-beverages.webp",
    link: "/search?category=Beverages",
  },
  {
    title: "Pre-Rolls",
    image: "/media/categories/covers/hero-pre-rolls.webp",
    link: "/search?category=Pre-Roll",
  },
  {
    title: "Accessories",
    image: "/media/categories/covers/hero-accessories.webp",
    link: "/search?category=Accessories",
  },
];
